module.exports = __webpack_public_path__ + "img/desc.6b0b088e.png";